import React from "react";
import { ShareButton } from "../../atoms/form/button/share";
import { Tooltip } from "../../atoms/tooltip";
import { Text } from "rebass/styled-components";
import { Subheader } from "../../text";
import styled from "styled-components";
import { trackClipSocialShare } from "./utils";

const UriString = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => props.theme.colors.chalk};
`;

const CopyButton = styled(Subheader)`
  border-radius: 4px;
  padding: 4px;
`;

export default function ClipboardShare({ classification, link, clip }) {
  const EncodedURI = encodeURI(link);
  classification = classification ? classification : "modalShare";

  return (
    <>
      <Tooltip
        position={{
          top: "-42px",
          padding: "10px",
          right: "-30px",
        }}
        type="click"
        timeout={true}
        theme="helpTooltip"
        align="right"
        tooltipContent="URL copied to clipboard!"
      >
        <ShareButton
          flex={false}
          mt="15px"
          width="100%"
          size="publish"
          justifyContent="space-between"
          classification="modalShare"
          alignItems="center"
          onClick={() => {
            if (clip) {
              trackClipSocialShare({
                platform: "Clipboard",
                isMontage: clip.isMontage,
                clip,
              });
            }

            navigator.clipboard.writeText(EncodedURI);
          }}
        >
          <UriString>{EncodedURI}</UriString>
          <CopyButton>COPY</CopyButton>
        </ShareButton>
      </Tooltip>
    </>
  );
}
